import { useEffect, useState } from "react";
import "./Step.scss";
import { GOOGLE_MAP_API_KEY } from "../../gMapsConfig";
import ReactGoogleAutocomplete from "react-google-autocomplete";

function StepSix({ onSubmit, send, setSend, formData, handleSubmit }) {
    const [inputLastname, setInputLastname] = useState(formData.lastname ?? "");
    const [inputFirstname, setInputFirstname] = useState(formData.firstname ?? "");
    const [inputEmail, setInputEmail] = useState(formData.email ?? "");
    const [inputPhone, setInputPhone] = useState(formData.phone ?? "");
    const [inputZipcode, setInputZipcode] = useState(formData.zipcode ?? "");
    const [inputCity, setInputCity] = useState(formData.city ?? "");
    const [inputAdress, setInputAdress] = useState(formData.adress ?? "");
    const [isSendDisabled, setIsSendDisabled] = useState(true);

    useEffect(() => {
        if (
            !inputLastname ||
            !inputFirstname ||
            !inputEmail ||
            !inputPhone ||
            !inputAdress ||
            !validateZipCode(inputZipcode) ||
            !inputCity ||
            !validateEmail(inputEmail) ||
            !validatePhone(inputPhone)
        ) {
            setIsSendDisabled(true);
            return;
        }
        onSubmit({
            lastname: inputLastname,
            firstname: inputFirstname,
            email: inputEmail,
            phone: inputPhone,
            adress: inputAdress,
            zipcode: inputZipcode,
            city: inputCity,
        });
        if (inputLastname && inputFirstname && inputEmail && inputPhone && inputAdress && inputZipcode && inputCity) {
            setSend(false);
            setIsSendDisabled(false);
        }
    }, [inputLastname, inputFirstname, inputEmail, inputPhone, inputAdress, inputZipcode, inputCity]);

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const validatePhone = (phone) => {
        return phone.match(/^(0|\+33|0033)[1-9]([-. ]?[0-9]{2}){4}$/);
    };

    const validateZipCode = () => /^\d{4,}$/.test(inputZipcode);

    return (
        <div className=" step step-six">
            <div>
                <p className="question question-six">Quelles sont vos coordonnées de contact ?</p>
                <div className="inputs">
                    <div className="flex-column">
                        <div className="input">
                            <label htmlFor="lastname">Nom</label>
                            <input
                                type="text"
                                id="lastname"
                                name="lastname"
                                value={inputLastname}
                                required
                                onChange={(e) => setInputLastname(e.target.value)}
                                placeholder="Nom"
                            ></input>
                        </div>
                        <div className="input">
                            <label htmlFor="firstname">Prénom</label>
                            <input
                                type="text"
                                id="firstname"
                                name="firstname"
                                value={inputFirstname}
                                required
                                onChange={(e) => setInputFirstname(e.target.value)}
                                placeholder="Prénom"
                            ></input>
                        </div>
                    </div>

                    <div className="input">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" value={inputEmail} onChange={(e) => setInputEmail(e.target.value)} placeholder="Email"></input>
                    </div>
                    <div className="input">
                        <label htmlFor="phone">Téléphone</label>
                        <input type="tel" id="phone" name="phone" value={inputPhone} onChange={(e) => setInputPhone(e.target.value)} placeholder="Téléphone"></input>
                    </div>
                    <div className="input">
                        <label htmlFor="adress">Adresse</label>

                        <ReactGoogleAutocomplete
                            id="adress"
                            name="adress"
                            placeholder="Adresse"
                            language="fr"
                            value={inputAdress}
                            apiKey={GOOGLE_MAP_API_KEY}
                            options={{
                                types: ["address"],
                                componentRestrictions: { country: "fr" },
                            }}
                            onChange={(e) => setInputAdress(e.target.value)}
                            onPlaceSelected={(place) => {
                                setInputAdress(place.formatted_address);
                                Object.values(place.address_components).forEach((comp) => {
                                    if (comp.types.find((type) => type === "locality")) {
                                        setInputCity(comp.long_name);
                                    }
                                    if (comp.types.find((type) => type === "postal_code")) {
                                        setInputZipcode(comp.long_name);
                                    }
                                });
                            }}
                        />
                    </div>
                    <p className="sentence-rgpd">
                        <em>
                            En soumettant ce formulaire, vous acceptez que vos données personnelles soient traitées conformément au RGPD et ne soient pas partagées avec des
                            tiers sans votre consentement.
                        </em>
                    </p>
                    <a href="/mentions-legales/" target="_blank">
                        Consulter nos mentions légales
                    </a>
                    <div className="button-end">
                        <button disabled={isSendDisabled} className="button-submit" onClick={handleSubmit}>
                            Envoyer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StepSix;
